import { NgModule } from '@angular/core';
import { ConversationComponent } from './conversation.component';
import { FacebookComponent } from './facebook/facebook.component';
import { LiveChatComponent } from './live-chat/live-chat.component';
import { ZaloComponent } from './zalo/zalo.component';
import { BrowserModule } from '@angular/platform-browser';
import { PaginatorModule } from 'primeng/primeng';
import { Select2Module } from 'ng2-select2';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { EmailComponent } from './email/email.component';
import { ZaloRedirectComponent } from './zalo/login_redirector/zalo.component';
import { ComponentsModule } from '../../../../../components/component.module';
import { SmsComponent } from './sms/sms.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    BrowserModule,
    PaginatorModule,
    Select2Module,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    ComponentsModule,
    RouterModule,
  ],
  declarations: [
    ConversationComponent,
    EmailComponent,
    FacebookComponent,
    LiveChatComponent,
    ZaloComponent,
    ZaloRedirectComponent,
    SmsComponent,
  ],
  exports: [
    ConversationComponent,
    EmailComponent,
    FacebookComponent,
    LiveChatComponent,
    ZaloComponent,
    ZaloRedirectComponent,
  ],
  providers: [],
})
export class ConversationModule {}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/conversation/conversation.module.ts